import script from "./legoSegmentButtonExtend.vue?vue&type=script&lang=js"
export * from "./legoSegmentButtonExtend.vue?vue&type=script&lang=js"

import "./legoSegmentButtonExtend.vue?vue&type=style&index=0&id=7e0aa437&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e0aa437"],['__file',"src/components/lego/extend/legoSegmentButtonExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e0aa437"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e0aa437', __exports__)) {
    api.reload('7e0aa437', __exports__)
  }
  
}


export default __exports__